import { createAsyncThunk } from '@reduxjs/toolkit';
import { handleError, handleResponse, MyAxios } from '@services/SettingAxios';
import { GetNewsDto } from './api.dto';
import { TypePromiseNews } from '@services/ServiceNews/TypePromise';
import { defaultDataNews } from '@services/ServiceNews/defaultDataApi';

export const fetchListNews = createAsyncThunk<TypePromiseNews, GetNewsDto>('news/fetchListNews', async ({ regionId, limit, type }) => {
  return await MyAxios.get('/api/news/get-news/', { params: { regionId, limit, type } })
    .then(handleResponse)
    .catch(error => handleError(error, defaultDataNews));
});
